import { QConfigTimeLimitType } from '@exam-management/graphql';
import { Box, Flex, List, ListItem, Text } from '@shared/components';
import { formatSecondsToHoursMinutes } from '@shared/utils';

import { type PickedQConfig } from '../../types';

interface TimeLimitInformationProps {
  timeLimit: PickedQConfig['metadata']['timeLimit'];
  structures: PickedQConfig['structures'];
}

export default function TimeLimitInformation(props: Readonly<TimeLimitInformationProps>) {
  const { timeLimit, structures } = props;

  if (!timeLimit || !timeLimit.total) {
    return '-';
  }

  if (timeLimit?.type === QConfigTimeLimitType.All) {
    return <Text>{formatSecondsToHoursMinutes(timeLimit.total, 'TEXT')}</Text>;
  }

  if (timeLimit?.type === QConfigTimeLimitType.ByStructure) {
    return (
      <List
        disablePadding
        sx={{
          listStyleType: 'disc',
          listStylePosition: 'inside',
          display: 'flex',
          flexDirection: 'column',
          gap: (theme) => theme.spacing(2),
        }}
      >
        {timeLimit.values.map((structure, order) => (
          <Box key={`time-limit-${structure.order}`}>
            <Flex>
              <Text variant='body2Semibold'>ช่วงเวลาที่ {order + 1}: </Text>
              <Text variant='body2'>{formatSecondsToHoursMinutes(structure.value, 'TEXT')}</Text>
            </Flex>
            {structure.qConfigStructureIds?.map((id) => (
              <Text key={id} variant='body2'>
                <ListItem
                  disablePadding
                  sx={{ display: 'list-item', pl: (theme) => theme.spacing(3.5) }}
                >
                  {structures.find((structure) => structure.id === id)?.name ?? '-'}
                </ListItem>
              </Text>
            ))}
          </Box>
        ))}
      </List>
    );
  }

  return null;
}
